/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Rounds a speed value (already converted to the user's configured units) to the nearest whole number, so that
 * every consumer rounds speed identically: the map speed display (PlotFormattingService.formatSpeed), the ECM
 * diagnostics panel (HTTP load) and the real-time socket mapper. This mirrors the map convention of applying
 * Math.round on top of the unit conversion.
 */
export function roundSpeed(speed: number): number {
  return Math.round(speed);
}
